import React from "react";
import {
  Box,
  Slider,
  TextField,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";

function RowGroup({
  label,
  showDropdown = false,
  dropdownOptions = [],
  dropdownValue = "",
  onDropdownChange,
  dropdownLabel = "Select Type",
  showSlider = true,
  sliderValue = 0,
  onSliderChange,
  sliderMin = 0,
  sliderMax = 1000000,
  sliderStep = 1000,
  showInput = true,
  inputValue = "",
  onInputChange,
  inputLabel = "Value",
  inputType = "number",
  ...props
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 0.5, sm: 1 },
        p: 1,
        flexWrap: "nowrap",
        width: "100%",
      }}
      {...props}
    >
      <Typography
        variant="body1"
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "0.875rem", sm: "1rem" },
        }}
      >
        {label}
      </Typography>
      <Box sx={{ flex: 1, minWidth: { xs: "30px", sm: "50px" } }}>
        <Slider
          value={sliderValue}
          onChange={onSliderChange}
          min={sliderMin}
          max={sliderMax}
          step={sliderStep}
          valueLabelDisplay="auto"
          size="small"
        />
      </Box>
      <TextField
        label={inputLabel}
        type={inputType}
        value={inputValue}
        onChange={onInputChange}
        variant="outlined"
        size="small"
        sx={{
          minWidth: { xs: "80px", sm: "100px" },
          "& .MuiInputLabel-root": {
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
          },
          "& .MuiInputBase-input": {
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
          },
        }}
      />
    </Box>
  );
}

export default RowGroup;
